/// <reference path="../../typings/index.d.ts" />

module monitoringApp.controllers {
    class ResultTypeController {
       private formData = {};
       constructor(private dataAccessService: common.DataAccessService){
          
       }

       private delete = (id) => {
            this.dataAccessService.deleteResultType(id).then(result => {
                if (result.status = 200) {
                    $(`tr[data-id=${id}]`).addClass('deleted');
                    setTimeout(() => {
                         $(`tr[data-id=${id}]`).addClass('hidden');
                    },400)
                }
            }); 
        }

        private update = () => this.dataAccessService.updateResultType(this.formData).then((result)=> {
           if (result.status == 200)
                window.history.back();
        });

         private create = () => this.dataAccessService.createResultType(this.formData).then((result)=> {
           if (result.status == 200)
                window.history.back();
        });
        
    }

    angular.module("ultimateMonitoringApp").controller("resultTypeController", ResultTypeController);
}
